import { BASE_API_URL } from '../envs.js';
import { authFetch } from './api-helper.js';
export async function postCookieLogin(username, password) {
    const response = await fetch(`${BASE_API_URL}/api/4/login`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
            username: username,
            password: password,
        }),
    });
    const userData = await response.json();
    return {
        userid: userData.userid,
        email: userData.name,
        firstName: userData.name,
        loginErrorCode: userData.loginErrorCode,
        loginErrorMsg: userData.loginErrorMsg,
    };
}
export async function postCookieLogout() {
    await fetch(`${BASE_API_URL}/api/4/logout`, {
        credentials: 'include',
        method: 'post',
    });
}
export async function fetchUserCheck() {
    const response = await fetch(`${BASE_API_URL}/api/4/check`, {
        credentials: 'include',
    });
    return response.json();
}
export async function fetchUserSettings() {
    const settings = await authFetch(`${BASE_API_URL}/api/4/usersettings`, true);
    const userSettings = await settings.json();
    return {
        color: userSettings.color,
        filterId: userSettings.filterid,
        timetype: userSettings.timetype,
        public: userSettings.public,
        opacity: userSettings.opacity,
        bicycleSpeed: userSettings.bicycle_speed,
        eBicycleSpeed: userSettings.e_bicycle_speed,
        hikeSpeed: userSettings.hike_speed,
        winterhikeSpeed: userSettings.winterhike_speed,
        snowshoeSpeed: userSettings.snowshoe_speed,
        mountainBikingSpeed: userSettings.mountainbike_speed,
        eMountainBikingSpeed: userSettings.e_mountainbike_speed,
        gpsPoints: userSettings.gps_points,
    };
}
//# sourceMappingURL=api-users.js.map